/*
 * ログイン（/）は infra/design-assets/css/halmek-custom.css の body
 *   display: flex; justify-content: center; align-items: center;
 * で「ロゴ＋カード」をビューポート内にまとめている。
 *
 * /settings/* は同じ body を使うが、ルートを minHeight:100vh 固定＋paddingTop だと
 * 縦方向の余白の付き方が TOP と一致しないため、Settings 側では本ルールを明示的に適用する。
 */

/** @param {import('@material-ui/core').Theme} theme */
export function authShellContentCentered(theme) {
	return {
		minHeight: '100vh',
		width: '100%',
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		justifyContent: 'center',
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
	};
}
